import {
  Message
} from 'element-ui'
/**
 * response 过滤器
 *
 * @export
 * @param {*} res
 * @returns
 */
export default function sideEffectDefault(state, res) {
  if (res.data && res.data.status == 302) {
     window.location = '/popadminweb/login'
  }
  if (res.data && res.data.status == 301) {
    Message({
      message: '你没有权限操作！',
      type: 'error',
      duration: 2 * 1000
    })
    window.location = '/popadminweb/login'
  }
  // console.log(state, res)
  if (state === 'start') {
    if (res.options && res.options.context) {
      if (res.options.context._isVue) {
        res.options.context.loading = true
      } else if (res.options.context.nodeType === 1) { // options为dom对象则修改disabled状态
        if (res.options.context.parentNode.disabled !== undefined) {
          res.options.context = res.options.context.parentNode
        }
        res.options.context.disabled = true
      }
    }
  } else if (state === 'complete') {
    if (res.options && res.options.context) {
      if (res.options.context._isVue) {
        res.options.context.loading = false
        res.options.context = null
      } else if (res.options.context.nodeType === 1) { // options为dom对象则修改disabled状态
        res.options.context.disabled = false
      }
    }
    if (res.options && res.options.successMsg) {
      Message({
        message: res.options.successMsg,
        type: 'success',
        duration: 2 * 1000
      })
    }
  } else if (state === 'filterError' || state === 'ajaxError') {
    if (res.options && res.options.context) {
      if (res.options.context._isVue) {
        res.options.context.loading = false
        res.options.context = null
      } else if (res.options.context.nodeType === 1) { // options为dom对象则修改disabled状态
        res.options.context.disabled = false
      }
    }
    if (!(res.options && res.options.errorMsg === 'none')) {
      // 增加了导出轮训的错误值204的判断
      if (res.error.errorCode === 204) {

      } else {
        Message({
          message: res.error.responseText || '网络错误',
          type: 'error',
          duration: 2 * 1000
        })

      }

    }
  }
}